import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withTranslation } from 'react-i18next';

import React, { Component } from "react"
import Slider from "react-slick"

import { throttle, isMobile, equalHeight } from "../../utilities/FrontFunctions/AoxGlobalFrontFunctions"
import ObjPushCardFormation from './ObjPushCardFormation'
import IconSVG from "../../utilities/FrontFunctions/IconSVG"

import '../../assets/css/0020_objects/0710_obj_carousel_formation.css'
import '../../assets/css/0020_objects/0840_obj_tabs_comptoir_dermato_formation.css'

class ObjTabsComptoirDermatoFormation extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isMobile: isMobile(),
            toggleState: 1, // État initial
            nbTabs: 3, // Nombre de Tabs
            titleTabs: [
                { label: "Continuer la lecture" },
                { label: "Mes favoris" },
                { label: "Les plus vues" }
            ],
            datasTrainings: props.datasTrainings,   //state parce que variation par handleButtonFav
        }
        this.handleWindowResizeMainHeader = this.handleWindowResizeMainHeader.bind(this)
        this.throttleWindowResizeMainHeader = throttle(this.handleWindowResizeMainHeader, 200)
		this.handleButtonFav = this.props.handleButtonFav.bind(this)
    }
    handleWindowResizeMainHeader() {
        this.setState({
            isMobile: isMobile()
        })
        this.applyEqualHeight()
    }

    componentDidMount() {
        this.applyEqualHeight()
        window.addEventListener('resize', this.throttleWindowResizeMainHeader)
    }
    componentWillUnmount() {
		window.removeEventListener('resize', this.throttleWindowResizeMainHeader)
    }
    applyEqualHeight() {
        setTimeout(() => {
            equalHeight(".obj_tabs_comptoir_dermato_formation .obj_tabs_list_content .obj_push_card .ctn_text_card");
        });
    }
    
    toggleTab = (index) => {
        this.setState({ toggleState: index })
        if (index >= 1 && index <= this.state.nbTabs) {
            this.setState({ toggleState: index });
        }
    }

    onSwipe() {
        if (this.slider) {
          	this.slider.innerSlider.clickable = true;
        }
	}
    render() {
        const { datasTrainings, toggleState, nbTabs, titleTabs } = this.state

        const sliderRef = slider => {this.slider = slider}
        const settings = {
            className: "obj_carousel_formation obj_carrousel_slider",
            centerMode: false,
			infinite: false,
			slidesToShow: 2,
            swipeToSlide: true,
            onSwipe: this.onSwipe.bind(this),
            dots: false,
            dotsClass: "slider-nav",
            appendDots: dots => (
                <div className="slider-nav" >
                    <ul> {dots} </ul>
                </div>
            ),
            arrows: true,
            speed: 750,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        centerPadding: "10%",
                        centerMode: true,
                        slidesToShow: 1,
                        dots: true,
                        arrows: false,
                    }
                }
            ]
        }

        return (<> {datasTrainings && <>
            <div className="obj_tabs_comptoir_dermato_formation">

                { this.state.isMobile &&
                                    
                    <div className="obj_navigation_header_formation">
                        <div className="ctn_nav">
                            {/* Bouton gauche */}
                            <button
                                className={`obj_btn_tab_arrow arrow_prev ${toggleState === 1 ? "is_disabled" : ""}`}
                                onClick={() => this.toggleTab(toggleState - 1)}
                                disabled={toggleState === 1}
                            >
                                <IconSVG icon="arrow_left" />
                            </button>
        
                            {/* Titres dynamiques */}
                            <div className="ctn_title">
                                {titleTabs.map((tab, index) => (
                                    <span
                                        key={index}
                                        className={`t_title ${toggleState === index + 1 ? "is_current" : "is_hidden"}`}
                                    >
                                        {tab.label}
                                    </span>
                                ))}
                            </div>
        
                            {/* Bouton droit */}
                            <button
                                className={`obj_btn_tab_arrow arrow_next ${toggleState === nbTabs ? "is_disabled" : ""}`}
                                onClick={() => this.toggleTab(toggleState + 1)}
                                disabled={toggleState === nbTabs}
                            >
                                <IconSVG icon="arrow_right" />
                            </button>
                        </div>
                    </div>

                }

                <div className="obj_tabs_list_tabs">
                    {titleTabs.map((tab, index) => (
                        <button
                            key={index}
                            className={toggleState === index + 1 ? "obj_btn_tab is_active" : "obj_btn_tab"}
                            onClick={() => this.toggleTab(index + 1)}
                        >
                            <span className="t_title">{tab.label}</span>
                        </button>
                    ))}
                </div>

                <div className="obj_tabs_list_content">
                    <div
                        className={toggleState === 1 ? "obj_tabs_content is_active" : "obj_tabs_content"}
                    >
                        {datasTrainings.TrainingsInProgress?.some(x => true) ?
                           <Slider {...settings} ref={sliderRef}>
                                {datasTrainings.TrainingsInProgress.map((datasTraining, index) => (
                                    <div className="item" key={index} >                                    
                                        <ObjPushCardFormation typeofPush="Formation" datasTraining={datasTraining} handleButtonFav={this.handleButtonFav}/>
                                    </div>
                                ))}
                            </Slider>
                        :
                           <>
                                <div className="ctn_title">
                                    <h3 className="t_title">&nbsp;</h3>
                                </div>
                                <div className="ctn_content">
                                    <p>Vous n’avez pas commencé de formation, choisissez-en une.</p>
                                </div>
                            </>
                        }
                    </div>

                    <div
                        className={toggleState === 2 ? "obj_tabs_content is_active" : "obj_tabs_content"}
                    >
                        {datasTrainings.TrainingsFavorite?.some(x => true) ?
                           <Slider {...settings} ref={sliderRef}>
                                {datasTrainings.TrainingsFavorite.map((datasTraining, index) => (
                                    <div className="item" key={index}>
                                        <ObjPushCardFormation typeofPush="Formation" datasTraining={datasTraining} handleButtonFav={this.handleButtonFav}/>
                                    </div>
                                ))}
                            </Slider>
                        :
                           <>
                                <div className="ctn_title">
                                    <h3 className="t_title">&nbsp;</h3>
                                </div>
                                <div className="ctn_content">
                                    <p>Vous n’avez pas de formation favorites.</p>
                                </div>
                            </>
                        }
                    </div>

                    <div
                        className={toggleState === 3 ? "obj_tabs_content is_active" : "obj_tabs_content"}
                    >
                        {datasTrainings.TrainingsMostView?.some(x => true) ?
                           <Slider {...settings} ref={sliderRef}>
                                {datasTrainings.TrainingsMostView.map((datasTraining, index) => (
                                    <div className="item" key={index}>
                                        <ObjPushCardFormation typeofPush="Formation" datasTraining={datasTraining} handleButtonFav={this.handleButtonFav}/>
                                    </div>
                                ))}
                            </Slider>
                        :
                           <>
                                <div className="ctn_title">
                                    <h3 className="t_title">&nbsp;</h3>
                                </div>
                                <div className="ctn_content">
                                    <p>Aucune formation vue</p>
                                </div>
                            </>
                        }
                    </div>
                </div>

            </div>
        </>}</>)
    }
}

export default withTranslation()(withSitecoreContext()(ObjTabsComptoirDermatoFormation));